module.exports = {
  // baseUrl: "http://3.108.209.226:8080",
  // url: "http://10.100.50.223/vpbx-apis/",

  // staging server
  // baseUrl: "http://103.197.46.236:8004",
  // url: "http://103.197.46.236:/vpbx-apis/",

  // live server
  // baseUrl: "http://10.180.77.71:8004",
  // url: "http://10.180.77.71:80/vpbx-apis/",
    // url: "http://localhost:80/vpbx-apis/",


    // live server
  //  baseUrl: "http://10.180.77.86:8004",
   baseUrl: "https://cap.zong.com.pk:8444/vpbx-apis/",
  url: "https://cap.zong.com.pk:8444/vpbx-apis/"
};
